import React from 'react';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import NvTooltip from 'shared/components/nv-tooltip';
import { CollapsibleRowMenuButton } from 'components/collapsible-row-menu';
import { MoveControls } from './types';

type MoveButtonsProps = {
  moveControls: MoveControls;
  rowMenuRef: React.RefObject<HTMLDivElement>;
};

const MoveButtons = ({ moveControls, rowMenuRef }: MoveButtonsProps) => {
  const { canMoveUp, onMoveUp, canMoveDown, onMoveDown } = moveControls;
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.PROGRAM_LEVEL_FIELDS;

  const swapRowMenu = (action: 'move-up' | 'move-down') => {
    const form = rowMenuRef.current?.closest('form');
    const sibling = (
      action === 'move-up' ? form?.previousElementSibling : form?.nextElementSibling
    ) as HTMLFormElement | null | undefined;

    const currentTrigger = rowMenuRef.current?.querySelector('.icon-in-progress')?.parentElement;
    const siblingTrigger = sibling?.querySelector('.icon-in-progress')?.parentElement;

    const callback = action === 'move-up' ? onMoveUp : onMoveDown;
    callback();
    // Collapse the current row menu
    currentTrigger?.click();
    // Expand the row menu of the new position
    siblingTrigger?.click();
  };

  return (
    <NvTooltip
      text={translationBase.DISABLED_STATE.MOVE_UP_DOWN()}
      enabled={!canMoveDown && !canMoveUp}
      placement='top'
      maxWidth={240}
    >
      <div className='d-flex'>
        <CollapsibleRowMenuButton
          icon='move-up'
          onClick={() => swapRowMenu('move-up')}
          disabled={!canMoveUp}
          data-qa={
            config.pendo.athena.mentorshipProgram.settings
              .programProfileSetup.updateProgramLevelProfileQuestion
          }
          aria-label={translationBase.ARIA_LABEL.MOVE_PROGRAM_LEVEL_QUESTION_UP()}
        />
        <CollapsibleRowMenuButton
          icon='move-down'
          onClick={() => swapRowMenu('move-down')}
          disabled={!canMoveDown}
          data-qa={
            config.pendo.athena.mentorshipProgram.settings
              .programProfileSetup.updateProgramLevelProfileQuestion
          }
          aria-label={translationBase.ARIA_LABEL.MOVE_PROGRAM_LEVEL_QUESTION_DOWN()}
        />
      </div>
    </NvTooltip>
  );
};

export default MoveButtons;
